import { FC } from "react";
import { Column } from "../../components/containers";
import { useThemeStore } from "../../stores";
import { Heading, Text } from "../../components/typography";
import { JustifyContent } from "../../components/containers/types";
import { useNavigate } from "react-router";

const ErrorPage: FC = () => {
  const theme = useThemeStore((state) => state.theme);
  const navigate = useNavigate();

  const goHome = (): void => {
    navigate("/");
  };

  return (
    <Column
      background={theme.background}
      style={{ width: "100vw", height: "100vh" }}
      justifyContent={JustifyContent.Center}
      gap={20}
    >
      <Heading
        textStyles={{ fontFamily: "monospace" }}
        color={theme.textOnBg}
        size={30}
      >
        Oops!
      </Heading>
      <Heading
        color={theme.textOnBg}
        size={30}
        textStyles={{ fontFamily: "monospace" }}
      >
        404 Not Found
      </Heading>
      <Text textStyles={{ fontFamily: "monospace" }} color={theme.textOnBg}>
        This page could not be found!
      </Text>
      <Column
        background={theme.secondary}
        style={{ padding: 10, borderRadius: 10, cursor: "pointer" }}
        props={{ onClick: goHome }}
      >
        <Text
          textStyles={{ fontFamily: "monospace" }}
          size={15}
          bold
          color={theme.textonSecondary}
        >
          Help me find my way home! ^^
        </Text>
      </Column>
    </Column>
  );
};

export default ErrorPage;
